import { AlphaNCircleIcon } from './AlphaNCircleIcon';

/**
 * author: Contributors
 * id 929903C6-6867-4884-8A02-7D72F1C44F2D
 * name alpha-n-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-n-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetNCircleIcon = AlphaNCircleIcon;
export default AlphabetNCircleIcon